<template>
  <div class="hello">
    <div class="zgheader">
      <div class="headertap">
        <router-link to="/home"><div class="headerlogo"></div></router-link>
        <div class="headermulu">
          <router-link to="/home">首页</router-link>
          <div style="display:inline-block; vertical-align: top;position: relative;" class="listt">           
            <router-link to="/features">解决方案 </router-link>
            <router-link to="/features/featurenewsm/channel" style="opacity: 0;position: absolute;left: 0;top: 0;width: 100%;height: 100%;padding: 0;"></router-link>
            <ul class="listpro" style="text-align: center">
              <li>
                <router-link to="/features/featurenewsm/channel" 
                  >私募/团队的业务管理</router-link
                >
              </li>
              <li>
                <router-link to="/features/featurenewsm/channel?id=fof">期货资管部门的业务管理</router-link>
              </li>
            </ul>
            </div>
          <router-link to="/register">申请体验</router-link>
          <router-link to="/download">相关下载</router-link>
        </div>
      </div>
    </div>
    <div class="zgmid">
      <router-view style="min-width: 1400px"></router-view>
    </div>
    <div class="zgfooter">
      <a
        style="
          font-size: 12px;
          display: block;
          width: 80px;
          margin: 0 auto;
          color: #416ae1;
          padding-top: 10px;
        "
        active-class="nosee"
        href="https://www.wenhua.com.cn/"
        target="_blank"
        >文华财经官网</a
      >
        <div
        style="
          width: 668px;
          margin: 0 auto;
          display: inline-block;
          letter-spacing: 0.5px;
          margin-top:4px;
          position: relative;
        "
      >
        © 上海文华财经资讯股份有限公司<span v-html="'&nbsp;&nbsp;&nbsp;'" style="padding:0"></span>ICP证号：沪B2-20110035
      <a
        href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502008976"
        target="_blank"
        style="position: absolute;right: 110px;bottom:-2px;"
        ><img src="../assets/img/anq.png"
      /></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.zgheader {
  position: absolute;
  top: 0;
  min-width: 1400px;
  width: 100%;
  height: 70px;
  line-height: 70px;
  /* filter: drop-shadow(0 2px 2px #a78f8f); */
  background: #171635;
  z-index: 9999;
}
.zgfooter {
  text-align: center;
  min-width: 1400px;
  width: 100%;

  height: 64px;

  margin: 0 auto;
  background-color: #1d2429;
  color: #e8e9ed;
  font-size: 12px;
  line-height: 20px;
}
.zgmid {
  width: 100%;
  margin-top: 70px;
}
.headertap {
  width: 1060px;
  margin: 0 auto;
}
.headermulu {
  float: right;
}
.headermulu a {
  padding: 0 20px;
  color: #fdfff9;
  text-decoration: none;
  font-size: 16px;
}
.headerlogo {
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=74) no-repeat center;
  width: 237px;
  height: 70px;
  float: left;
}
.router-link-active {
  background: #f1b869;
  color: #1f1738 !important;
}
.headermulu a {
  height: 70px;
  display: inline-block;
}
.headermulu a:hover {
  color: #f1b869;
}
.listpro{
  position: absolute;
  height: 0;
  overflow: hidden;
  margin-top: -2px;
}
.listpro li a{
  height:40px;
  line-height: 40px;
  background: #f6fbfe;
  width: 190px;
  padding: 0 10px;
  color: #565565;
}
.listpro li{
  height:40px;
  line-height: 40px;
  text-align: left;
   background: #f6fbfe;
  width: 200px;
}
.listt:hover .listpro{
  height: 80px;
  border: 1px solid #d0cfe0;
}
.listpro li a:hover{
 background: #f4e3d3;
  
}
</style>
